import { IS_UPCOMING_SESSIONS_ENABLED } from '@/features/flags';
import { isLetterSenderEHRProvider } from '@/features/integrations-letters/letter-sender/helpers';
import { useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';

export const useShouldUseUpcomingSessions = () => {
  const { integrationEhrProvider } = useIntegrationEhrInfo();

  return (
    IS_UPCOMING_SESSIONS_ENABLED() &&
    (!integrationEhrProvider || isLetterSenderEHRProvider(integrationEhrProvider))
  );
};
